import React from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import { Alert, AlertTitle } from '@material-ui/lab';
import ErrorOutlineOutlinedIcon from '@material-ui/icons/ErrorOutlineOutlined';

import { Confirm } from '../../../../components';
import { user as userActions } from '../../../../actions';
import makeClasses from './styles';

const getDeviceTraceId = (tap) => tap?.deviceTraceId ?? tap?.traceId;

const DeleteModal = ({ open, onClose, handyTap, i18n, onSuccess }) => {
  const dispatch = useDispatch();
  const classes = makeClasses();

  const handleConfirm = () => {
    const deviceTraceId = getDeviceTraceId(handyTap);
    if (!deviceTraceId) {
      onClose();
      return;
    }

    dispatch(
      userActions.deleteHandyTap(deviceTraceId, (ok) => {
        if (ok) {
          onSuccess?.();
        }
      })
    );

    onClose();
  };

  return (
    <Confirm
      open={open && !!handyTap}
      onClose={onClose}
      title={i18n.get('ManageHandyTap.DeleteDialogTitle')}
      confirmText={i18n.get('ManageHandyTap.DeleteDialogActionConfirm')}
      onConfirm={handleConfirm}
      cancelText={i18n.get('ManageHandyTap.DeleteDialogActionCancel')}
      onCancel={onClose}
    >
      <Alert severity="error" icon={false} className={clsx(classes.alert, classes.alertDanger)}>
        <div>
          <ErrorOutlineOutlinedIcon className={classes.alertIcon} />
        </div>
        <div className={classes.alertMessage}>
          <AlertTitle className={classes.alertTitle}>
            {i18n.get('ManageHandyTap.DeleteDialogContentTitle')}
          </AlertTitle>
          {i18n.get('ManageHandyTap.DeleteDialogContentText')}
        </div>
      </Alert>
    </Confirm>
  );
};

export default DeleteModal;
